class ShopifyProductManager {
  async updateShippingProduct(oldItemKey, newVariantId, vendor, shippingVariant) {

    const config = this.fetchConfig('javascript');

    try {
      const response = await fetch("/cart/update.js", {...config, body: JSON.stringify({
        'updates': {
          [oldItemKey]: 0,
        }
      })});
      const data = await response.json();
      await this.addShippingProduct(newVariantId, vendor, shippingVariant);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {scrollToTop: false}
      }));
      
    } catch (e) {
      console.error(e);
    }
  }

  async addShippingProduct(variantId, vendor, shippingVariant) {
    const formData = new FormData();
    formData.append('quantity', '1');
    formData.append('form_type', 'product');
    formData.append('id', variantId);
    formData.append('properties[_shipping_product]', "true");
    formData.append(`properties[_vendor]`, vendor);
    formData.append(`properties[Seller]`, vendor);
    formData.append('properties[_limit_qty]', "true");

    formData.append('properties[_shipping_n1]', shippingVariant._shipping_n1);
    formData.append('properties[_shipping_v1]', shippingVariant._shipping_v1);
    formData.append('properties[_shipping_q1]', shippingVariant._shipping_q1);
    formData.append('properties[_shipping_s1]', shippingVariant._shipping_s1);
    formData.append('properties[_shipping_w1]', shippingVariant._shipping_w1);
    formData.append('properties[_shipping_q2]', shippingVariant._shipping_q2);
    formData.append('properties[_shipping_q3]', shippingVariant._shipping_q3);
    formData.append('properties[_shipping_q4]', shippingVariant._shipping_q4);
    formData.append('properties[_shipping_s2]', shippingVariant._shipping_s2);
    formData.append('properties[_shipping_n2]', shippingVariant._shipping_n2);
    formData.append('properties[_shipping_nt1]', shippingVariant._shipping_nt1);
    formData.append('properties[_shipping_w2]', shippingVariant._shipping_w2);
    formData.append('properties[_shipping_w3]', shippingVariant._shipping_w3);
    formData.append('properties[_shipping_nf]', shippingVariant._shipping_nf);
    formData.append('properties[_shipping_t1]', shippingVariant._shipping_t1);
    formData.append('properties[_shipping_v2]', shippingVariant._shipping_v2);
    formData.append('properties[_shipping_rural]', shippingVariant._shipping_rural);
    formData.append('properties[_shipping_metro]', shippingVariant._shipping_metro);

    const config = this.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    config.body = formData;
    try {
      const response = await fetch("/cart/add", config);
      const data = await response.json();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {scrollToTop: false}
      }));
      
    } catch (e) {
      console.error(e);
    }
  }

  fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  async fixQuantity(id) {
    console.log("returned cart", "fixing")

    const body = JSON.stringify({
      id: id.toString(),
      quantity: 1,
    });

    try {
      const response = await fetch("/cart/change", {...this.fetchConfig(), ...{ body }});
      const state = await response.text();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {scrollToTop: false}
      }));
    } catch (e) {
      console.error(e);
    }
  }

  async removeFreeProduct(id) {
    console.log("returned cart", "remove")
    const formData = new FormData();
    formData.append('quantity', '0');
    formData.append('form_type', 'product');
    formData.append('id', id);


    const body = JSON.stringify({
      id: id.toString(),
      quantity: 0,
    });

    try {
      const response = await fetch("/cart/change", {...this.fetchConfig(), ...{ body }});
      const state = await response.text();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {scrollToTop: false}
      }));
    } catch (e) {
      console.error(e);
    }
  }
}

class ShippingsLogic {
  constructor() {
    this.ShopifyFreeProductManager = new ShopifyProductManager();
    this.shippingSettings = this._getShippingSettings();
    this.process();
    this._bindEventListeners();
  }

  lockCheckout() {
    document.querySelectorAll("button[name='checkout']").forEach((elm) => {
      elm.setAttribute("disabled", true);
    });
    this.waitForElm("#shopify-section-mini-cart button[name='checkout']").then((elm) => {
      elm.setAttribute("disabled", true);
    });
    return setInterval(() => {
      document.querySelectorAll("button[name='checkout']").forEach((elm) => {
        elm.setAttribute("disabled", true);
      },10);
    });
  }

  unlockCheckout(int) {
    clearInterval(int);
    document.querySelectorAll("button[name='checkout']").forEach((elm) => {
      elm.removeAttribute("disabled");
    });
    this.waitForElm("#shopify-section-mini-cart button[name='checkout']").then((elm) => {
      elm.removeAttribute("disabled");
    });
  }

  waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  }

  lastCart

  async process() {
    console.log("returned cart", "process run")
    const int = this.lockCheckout();
    this.shippingSettings && console.log(this.shippingSettings, "shippingSettings")

    if (!this.shippingSettings) return;

    const cart = await this._getCart();
    if (JSON.stringify(cart) != JSON.stringify(this.lastCart)) {
      this.lastCart = cart
      await this._processShippingSettings(cart);
      await this._edgeCaseRemoveShippingProduct(cart);
    }
    this.unlockCheckout(int);
    console.log("returned cart", "process finished")
  }

  async _processShippingSettings(cart) {

    await this._addEligibleVendorsShippingProducts(cart);
  }

  _getCorrectTypeValue(currVal, type) {
    if (type == 'weight') return currVal.grams;

    if (type == 'price') return currVal.price;

    if (type == 'flat') return currVal.sku

    return 0;
  }

  shippingProducts = {}

  async _addEligibleVendorsShippingProducts(cart) {
    let cartItems = []
    let customShipping = []
    for (let item of cart.items) {
      // don't add shipping for skus tagged with free shipping
      let product
      if (this.shippingProducts[item.handle]) {
        product = this.shippingProducts[item.handle]
      } else {
        const res = await fetch(`${window.location.origin}/products/${item.handle}.json`);
        product = await res.clone().json();
        this.shippingProducts[item.handle] = product
      }
      if (!product.product.tags || (!product.product.tags.includes('free-shipping:'+item.sku) && !product.product.tags.includes('free-shipping:all') && !product.product.tags.includes('custom-shipping:'+item.sku+':'))) {
        cartItems.push(item)
      }

      const tags = product.product.tags.split(', ').filter(t => {console.log(t);return t.includes('custom-shipping:'+item.sku)})
      if (tags.length) {
        customShipping.push(tags[0].split(':')[2])
      }
    }
    console.log('custom shipping',customShipping)

    let vendorsInCart = cartItems.reduce((acc, currVal) => {

      if(currVal.title.toLowerCase().indexOf('pickup only') > -1) {
        console.log('PICKUP ONLY'); return acc
      }
      console.log(currVal.title.toLowerCase());
      if (currVal.title.toLowerCase().indexOf('tgt hard-shell rooftop tent') > -1) {
        console.log("ENTER");
        currVal.vendor = "Tough Gear::TGT Hard-Shell Rooftop Tent"
      }
      if (currVal.title.toLowerCase().indexOf('disabled xgg') > -1) {
        console.log('SKIPING XGG')
        return acc;
      }
      if (currVal.properties?._shipping_product == 'true') {
        if (acc[`${currVal.vendor}`]) {
          return acc;
        } else {
          return { ...acc, [`${currVal.vendor}`]: 0 }
        }
      };

      const vendorSettings = this.shippingSettings.find((setting) => setting.vendor == currVal.vendor);
      if (!vendorSettings) return acc;

      const type = vendorSettings.type;

      if (acc[`${currVal.vendor}`]) {
        if (type === 'flat') return { ...acc, [`${currVal.vendor}`]: this._getCorrectTypeValue(currVal, type) };
        else return { ...acc, [`${currVal.vendor}`]: this._getCorrectTypeValue(currVal, type) + acc[`${currVal.vendor}`] }
      } else {
        if (type === 'flat') return { ...acc, [`${currVal.vendor}`]: this._getCorrectTypeValue(currVal, type) };
        return { ...acc, [`${currVal.vendor}`]: this._getCorrectTypeValue(currVal, type) * currVal.quantity } 
      }
    }, {});
    
    console.log(vendorsInCart, "vendorsInCart")


    for (const key in vendorsInCart) {
      const vendorSettings = this.shippingSettings.find((setting) => setting.vendor == key);
      if (!vendorSettings) continue;

      const value = vendorsInCart[key];

      switch (vendorSettings.type) {
        case 'price': 
          await this._logicForPrice(cart, vendorSettings, value, key);
          break;
        case 'weight':
          await this._logicForWeight(cart, vendorSettings, value, key);
          break;
        case 'flat':
          await this._logicForFlat(cart, vendorSettings, value, key);
          break;
        default:
          break;
      }
    }

    if (customShipping.length) {
      this._logicForTagShipping(cart, customShipping)
    } else {
      this.removeCustomShipping(cart,[])
    }

    for (const line_item of cartItems) {
      if (line_item.product_type == 'Shipping' && line_item.quantity > 1) {
        console.log('returned cart',"qty too high" )
        this.ShopifyFreeProductManager.fixQuantity(line_item.id)
      }
    }


  }

  async removeCustomShipping(cart, okItems) {
    console.log('tag_shipping','start remove')
    const response =  await fetch(window.Shopify.routes.root + 'products/shipping-by-tags.json')
    const shippingProduct = await response.json()
    const shippingProductsIds = shippingProduct.product.variants.map(v => v.id);

    let badItems = []
    for (let lineId of shippingProductsIds) {
      if (!okItems.includes(lineId)) {
        badItems.push(lineId)
      }
    }

    for (let i of cart.items) {
      if (badItems.includes(i.variant_id)) {
        console.log('tag_shipping','removing item')
        await this.ShopifyFreeProductManager.removeFreeProduct(i.id);
      }
    }

  }

  async _logicForTagShipping(cart, customShipping) {
    console.log('tag_shipping', 'start add')
    const response =  await fetch(window.Shopify.routes.root + 'products/shipping-by-tags.json')
    const shippingProduct = await response.json()
    const shippingProductsIds = shippingProduct.product.variants.map(v => v.id);
    let listIds = []
    for (const item of customShipping) {

      const eligibleShippingVariants = shippingProduct.product.variants.filter(v => {
        return v.title == item
      });

      if (!eligibleShippingVariants[0]) return;

      const currentShippingItem = cart.items.find(i => shippingProductsIds.indexOf(i.variant_id) > -1);

      if(!currentShippingItem) {
        console.log('tag_shipping', 'adding item')
        await this.ShopifyFreeProductManager.addShippingProduct(eligibleShippingVariants[0].id, '', eligibleShippingVariants[0])
      }

      listIds.push(eligibleShippingVariants[0].id)
    }

    this.removeCustomShipping(cart, listIds)
  }

  async _logicForFlat(cart, vendorSettings, sku, key) {
    const shippingProduct = vendorSettings.shipping_product;
    if (!shippingProduct) return;

    const shippingProductsIds = shippingProduct.variants.map(v => v.id);

    // console.log({variants});
    const eligibleShippingVariant = shippingProduct.variants.find(v => v.title == 'default');

    console.log(eligibleShippingVariant, "eligibleShippingVariantFLAT")

    if (!eligibleShippingVariant) return;

    const currentShippingItem = cart.items.find(i => shippingProductsIds.indexOf(i.variant_id) > -1);

    console.log(currentShippingItem, "currentShippingItem");

    if (!currentShippingItem) {
      await this.ShopifyFreeProductManager.addShippingProduct(eligibleShippingVariant.id, key, eligibleShippingVariant);
    } else if (currentShippingItem && currentShippingItem.variant_id !== eligibleShippingVariant.id) {
      await this.ShopifyFreeProductManager.updateShippingProduct(currentShippingItem.variant_id, eligibleShippingVariant.id, key, eligibleShippingVariant);
    }

    await this._removeNotEligibleVendorsShippingProducts(cart, shippingProductsIds);
  }


  async _logicForWeight(cart, vendorSettings, weight, key) {

    const shippingProduct = vendorSettings.shipping_product;
    if (!shippingProduct) return;

    const weightKg = weight / 1000;
    const shippingProductsIds = shippingProduct.variants.map(v => v.id)
    const eligibleShippingVariants = shippingProduct.variants.filter(v => {
      const optionNumber = v.option1.match(/\d+(\.\d+)?/)[0];
        return parseFloat(optionNumber) > weightKg;
    });
    if (!eligibleShippingVariants || eligibleShippingVariants.length == 0) return;

    const currentShippingItem = cart.items.find(i => shippingProductsIds.indexOf(i.variant_id) > -1);

    console.log(currentShippingItem, "currentShippingItem")
    if(!currentShippingItem) {

      await this.ShopifyFreeProductManager.addShippingProduct(eligibleShippingVariants[0].id, key, eligibleShippingVariants[0])
    } else if(currentShippingItem && currentShippingItem.variant_id != eligibleShippingVariants[0].id) {
      await this.ShopifyFreeProductManager.updateShippingProduct(currentShippingItem.variant_id, eligibleShippingVariants[0].id, key, eligibleShippingVariants[0])
    }

    await this._removeNotEligibleVendorsShippingProducts(cart, shippingProductsIds)
  }

  async _logicForPrice(cart, vendorSettings, priceCents, key) {
    console.log("price logic");

    const shippingProduct = vendorSettings.shipping_product;
    if (!shippingProduct) return;

    const price = priceCents / 100;
    const shippingProductsIds = shippingProduct.variants.map(v => v.id)
    const eligibleShippingVariants = shippingProduct.variants.filter(v => {
      const optionNumber = v.option1.match(/\d+(\.\d+)?/)[0];
        return parseFloat(optionNumber) > price;
    });

    const currentShippingItem = cart.items.find(i => shippingProductsIds.indexOf(i.variant_id) > -1)
    if (!eligibleShippingVariants || eligibleShippingVariants.length == 0 || price == 0) {
      if (currentShippingItem) {
        await this.ShopifyFreeProductManager.removeFreeProduct(currentShippingItem.id);
        return; // if no eligible variants and we have shipping product in cart, we remove it
      }
      return;
    }

    if(!currentShippingItem) {
      await this.ShopifyFreeProductManager.addShippingProduct(eligibleShippingVariants[0].id, key, eligibleShippingVariants[0])
    } else if(currentShippingItem && currentShippingItem.variant_id != eligibleShippingVariants[0].id) {
      await this.ShopifyFreeProductManager.updateShippingProduct(currentShippingItem.variant_id, eligibleShippingVariants[0].id, key, eligibleShippingVariants[0])

    }
  }

  async _removeNotEligibleVendorsShippingProducts(cart, shippingProductsIds) {
    const shippingProductIdsToRemove = [];

    cart.items.forEach((item) => {
      const vendor = item.vendor;
      const productOfVendor = cart.items.filter((item) => {
        return item.vendor == vendor && !shippingProductsIds.includes(item.variant_id);
      });
      if (productOfVendor.length > 0) return;
      shippingProductIdsToRemove.push(item.id);
    });

    for (let lineId of shippingProductIdsToRemove) {
      await this.ShopifyFreeProductManager.removeFreeProduct(lineId);
    }
  }

  async _edgeCaseRemoveShippingProduct(cart) {
    const shippingProductIdsToRemove = [];
    this.shippingSettings.forEach((setting) => {
      const vendor = setting.vendor;
      const shippingProducts = cart.items.filter((item) => {
        return item.vendor == vendor && item.properties?._shipping_product == 'true';
      });
      if (shippingProducts.length <= 1) return;

      shippingProducts.forEach((item, index) => {
        shippingProductIdsToRemove.push(item.id);
      });
    });

    for (let lineId of shippingProductIdsToRemove) {
      await this.ShopifyFreeProductManager.removeFreeProduct(lineId);
    }

    console.log("edge case finished");
  }

  _getShippingSettings() {
    const script = document.querySelector("[shipping-logic-settings]");
        if (!script) return null;
    
        return JSON.parse(script.innerHTML);
  }

  _bindEventListeners() {
    this._cartListener();
    this._checkoutBtnListener();
  }

  _checkoutBtnListener() {

    setTimeout(() => {
      const form = document.querySelector("#mini-cart-form");
      if(!form) return
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        console.log("SUBMIT");
        console.log('returned cart',"checkout button")
        await this.process();
        window.location.href = "/checkout";
      });

      const chkoutBtn = document.getElementById('side-cart-checkout-btn')
      chkoutBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        console.log('returned cart',"checkout button2")
        await this.process();
        window.location.href = "/checkout";
      });
    }, 2000);

    const formStandardCart = document.querySelector(".cart-recap");
    if(!formStandardCart) return 
    formStandardCart.addEventListener('submit', async (e) => {
      e.preventDefault();
      console.log("SUBMIT");
      await this.process();
      window.location.href = "/checkout";
    });

  }

  _cartListener() {
    const handleCartEvent = (e) => {
      this.process();
    };

    window.addEventListener('shopify_cart_add', handleCartEvent);
    window.addEventListener('shopify_cart_change', handleCartEvent);
  }

  async _getCart() {
    const res = await fetch(`${window.location.origin}/cart.js`);
    
    const data = await res.clone().json();
    
    return data;
  }
}

document.addEventListener("DOMContentLoaded", function() {
  new ShippingsLogic();
});
